<template>
    <div>
        <nav-header></nav-header>
        <div class="projectdashboard-form validate-form p-l-50 p-r-50 p-t-10 p-b-80" >
            <section>
                <div class="page-title">
                    <h2>Administração</h2>
                </div>
                <hr/>
                <dashboard
                :companyId="companyId"
                >
                </dashboard>
            </section>
        </div>
           
        <user-profile-footer></user-profile-footer>
    </div>
</template>

<style scoped>
    .dropdown-content {
        z-index: 10 !important;
    }
</style>

<script>
    import NavHeader from "../components/NavHeader.vue";
    import UserProfileFooter from '../components/UserProfileFooter.vue'
    import Dashboard from '../components/Dashboard.vue'

    export default {
        components: { UserProfileFooter, NavHeader, Dashboard },

        data(){
            return {
                companyId: this.$store.getters["auth/user"].CompanyId

            }
        }
        
    }
</script>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
   .chartDescription{
       text-align: center;
   }

   month-picker-input{
       align-self: center;
   }
</style>